"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var moment = require("moment");
function SET_CRUISE_PARAMETERS(state, params) {
    var id = params.id, priceModel = params.priceModel;
    if (!state.cruise) {
        state.cruise = params;
    }
    if (id) {
        state.cruise.id = id.toUpperCase();
    }
    if (priceModel) {
        state.cruise.priceModel = priceModel.toUpperCase();
    }
}
exports.SET_CRUISE_PARAMETERS = SET_CRUISE_PARAMETERS;
function SET_CRUISE_DATA(state, params) {
    var data = params.cruise;
    var format = 'DD.MM.YYYY';
    var departureDate = moment(data.departure, format);
    var duration = moment(data.arrival, format).diff(departureDate, 'days');
    var daysTillDeparture = departureDate.diff(moment(), 'days');
    var shortTerm = daysTillDeparture <= 4;
    var routeName = data.name;
    state.cruise = lodash_1.merge(state.cruise, data, { duration: duration, shortTerm: shortTerm, routeName: routeName });
}
exports.SET_CRUISE_DATA = SET_CRUISE_DATA;
function SET_STATIC_DATA(state, params) {
    state.validations = params.formValidations;
    state.countries = params.countries;
    state.paymentCountries = params.paymentCountries;
    state.sexes = params.sexes;
}
exports.SET_STATIC_DATA = SET_STATIC_DATA;
function SET_BOOK_LOADER(state, ok) {
    state.booking.loading = ok;
}
exports.SET_BOOK_LOADER = SET_BOOK_LOADER;
function SET_BOOK_NUMBER(state, number) {
    state.booking.number = number;
}
exports.SET_BOOK_NUMBER = SET_BOOK_NUMBER;
function SET_BOOK_ERROR(state, error) {
    state.booking.error = error;
}
exports.SET_BOOK_ERROR = SET_BOOK_ERROR;
function SET_BOOK_CONFIRMATION(state, params) {
    // should never be executed by SSR
    var token = typeof window !== 'undefined' && window && window['jwt-token']
        ? window['jwt-token']
        : '';
    var _a = params.buyer, firstName = _a.firstName, lastName = _a.lastName;
    var serviceCruise = lodash_1.find(params.services, {
        type: 'CRU',
    });
    var url = "confirmationPdf?cruiseId=" + serviceCruise.id +
        ("&bookingNumber=" + state.booking.number) +
        ("&firstName=" + firstName + "&lastName=" + lastName) +
        ("&Authorization=" + token);
    state.booking.confirmation = url;
}
exports.SET_BOOK_CONFIRMATION = SET_BOOK_CONFIRMATION;
function SET_SHIPS(state, ships) {
    state.ships = ships;
}
exports.SET_SHIPS = SET_SHIPS;
exports.default = {
    SET_CRUISE_PARAMETERS: SET_CRUISE_PARAMETERS,
    SET_CRUISE_DATA: SET_CRUISE_DATA,
    SET_STATIC_DATA: SET_STATIC_DATA,
    SET_BOOK_LOADER: SET_BOOK_LOADER,
    SET_BOOK_NUMBER: SET_BOOK_NUMBER,
    SET_BOOK_ERROR: SET_BOOK_ERROR,
    SET_BOOK_CONFIRMATION: SET_BOOK_CONFIRMATION,
    SET_SHIPS: SET_SHIPS,
};
//# sourceMappingURL=mutations.js.map